<div class="p8-bdc_header__container" fxLayout="row">

  <div class="mat-headline">
    <ng-container *ngFor="let title of titlePath; last as isLast">
      <span *ngIf="!isLast" class="p8-secondary">{{ title }}</span>
      <span *ngIf="!isLast" class="p8-secondary" style="font-weight: 300;"> / </span>
      <span *ngIf="isLast">{{ title }}</span>
    </ng-container>
  </div>

  <div fxFlex></div>

  <ng-content></ng-content>
</div>
